import siteConfig from '@/localized/config/site';

export const domain = `https://${siteConfig.siteNameLower}.com`;
export const s2Domain = `https://s2.${siteConfig.siteNameLower}.com`;
export const seoImagePath = siteConfig.seoImagePath;
export const faviconPath = siteConfig.favicon;
